import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AccountService } from '../../services/account.service';
import { Router } from '@angular/router';

const SPLASH_ICONS = ['close', 'arrow_forward', 'expand_more', 'check_circle', 'person', 'verified_user'];

@Component({
    selector: 'app-start-page',
    templateUrl: './start-page.component.html',
    styleUrls: ['./start-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StartPageComponent {
  doNotShowChecked: boolean = false;
  moreInfoExpanded = false;
  readonly closeLabel = $localize`:@@einvoice.start-page.close:Close`;

  constructor(
    private accountService: AccountService,
    private router: Router,
    matIconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer
    ) {
    for (const icon of SPLASH_ICONS) {
      matIconRegistry.addSvgIcon(icon, sanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${icon}.svg`));
    }
  }

  // Files are only accepted in the viewer, so swallow drops before the app-level dropzone sees them.
  @HostListener('dragover', ['$event'])
  @HostListener('drop', ['$event'])
  blockFileDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'none';
    }
  }

  toggleMoreInfo(): void {
    this.moreInfoExpanded = !this.moreInfoExpanded;
  }

  getLink(linkname: string):string {
    switch (linkname) {
      case 'privacy': return $localize`:@@einvoice.start-page.link.privacy:https://www.business-one.cloud/privacy`;
      case 'imprint': return $localize`:@@einvoice.start-page.link.imprint:https://www.business-one.cloud/imprint`;
      case 'conesprit': return 'https://conesprit.de/';
      default: return '#';
    }
  }

  startApp() {
    if (this.doNotShowChecked) {
      this.accountService.setDonotshowStartpage();
    }
    this.router.navigate(['/']).catch(() => ({}));
  }

}
